const megamenu = {
  el: {
    items: null as NodeListOf<HTMLElement> | null,
    activeItems: null as NodeListOf<HTMLElement> | null,
  },
  init() {
    this.el.items = document.querySelectorAll('.secondary-navigation__link--has-children')
    this.el.activeItems = document.querySelectorAll('.navigation-active')

    if (!this.el.items.length) {
      return
    }

    this.el.items.forEach((item) => {
      item.removeEventListener('click', this._boundHandleClick)
      item.addEventListener('click', this._boundHandleClick)
    })
  },
  _boundHandleClick: null as EventListener | null,

  handleClick(e: Event) {
    e.preventDefault()
    e.stopPropagation()

    const target = e.currentTarget as HTMLButtonElement
    const megaMenu = document.querySelector('.megamenu') as HTMLElement

    if (!target.classList.contains('navigation-active')) {
      this.open(target, megaMenu)
    } else {
      this.close()
    }
  },

  open(target: HTMLButtonElement, megaMenu: HTMLElement) {
    const allLinks = this.el.items
    allLinks.forEach((link) => link.classList.remove('navigation-active'))

    target.classList.add('navigation-active')
    megaMenu.classList.remove('megamenu--hidden')
    megaMenu.dataset.state = 'open'
  },

  close() {
    const megaMenu = document.querySelector('.megamenu') as HTMLElement
    const activeItem = document.querySelector('.navigation-active') as HTMLButtonElement
    const inner = document.querySelector('.megamenu__inner') as HTMLElement

    if (activeItem) {
      activeItem.classList.remove('navigation-active')
    }
    megaMenu.classList.add('megamenu--hidden')
    megaMenu.dataset.state = 'closed'

    if (inner) {
      inner.remove()
    }
  },

  reapplyState() {
    const megaMenu = document.querySelector('.megamenu') as HTMLElement

    if (megaMenu.dataset.state === 'open') {
      megaMenu.classList.remove('megamenu--hidden')
    } else {
      megaMenu.classList.add('megamenu--hidden')
    }
  },
}

// Bind `handleClick` correctly before initializing
megamenu._boundHandleClick = megamenu.handleClick.bind(megamenu)

export default megamenu
